import React from 'react';
import RichLayout from '@components/_struct/_layouts/RichLayout';
import { useMSTranslation } from '@utils/useMSTranslation';
import Head from 'next/head';

const Mentions = () => {
    const { __ } = useMSTranslation(['mentions']);

    return (
        <RichLayout>
            <Head>
                <title>{__('Mentions légales', 'mentions')} | Viseet.me</title>
            </Head>
            <h1>{__('Mentions légales', 'mentions')}</h1>
            <h3>{__('Editeur', 'mentions')}</h3>
            <p>{__('Directeur de publication : Maxence Wibaux', 'mentions')}</p>
            <p>
                {__(
                    'Société : VISEET, SAS au capital de 256 413 euros',
                    'mentions'
                )}
                <br /> 59 rue de l’ancienne mairie <br />
                92100 Boulogne Billancourt
            </p>
            <p>897 655 643 RCS Nanterre</p>
            <h3>{__('Hébergeur', 'mentions')}</h3>
            <p>
                OVH
                <br />
                2 rue Kellermann
                <br />
                59100 Roubaix
                <br />
                France
                <br />
            </p>
            <h3>{__('Propriété Intellectuelle', 'mentions')}</h3>
            <p>
                {__(
                    "Tous les textes, commentaires, ouvrages, illustrations, œuvres et images reproduits ou représentés sur le Site sont strictement réservés au titre du droit d'auteur ainsi qu'au titre de la propriété intellectuelle et pour le monde entier. À ce titre et conformément aux dispositions du Code de la propriété intellectuelle, seule l'utilisation pour un usage privé sous réserve de dispositions différentes voire plus restrictives du Code de la propriété intellectuelle est autorisée. Toute reproduction ou représentation totale ou partielle du site ou de tout ou partie des éléments se trouvant sur le site est strictement interdite. Toute mise en place de liens hypertextes vers le site sans autorisation expresse de VISEET est également strictement interdite. Toute utilisation frauduleuse des marques, modèles, logos et dénominations apparaissant sur le Site, en fraude des droits de VISEET ainsi que de ses sociétés et enseignes, constitue un acte de contrefaçon susceptible d’engager la responsabilité de son auteur sur le fondement des articles L713-2 et suivants du Code de la propriété intellectuelle, et des textes communautaires et internationaux en la matière.",
                    'mentions'
                )}
            </p>
            <h3>{__('Loi « Informatique et Liberté et RGPD»', 'mentions')}</h3>
            <p>
                {__(
                    "En effectuant une demande ou s'enregistrant via le site www.viseet.me, le Client consent à l'utilisation par VISEET des données nominatives le concernant. Ces données sont nécessaires pour assurer le bon traitement de sa demande. Conformément à la loi informatique et libertés du 6 janvier 1978 et au règlement UE 2016/679 du 27 avril 2016 (RGPD), le Client dispose d'un droit d'accès et de rectification et d'opposition aux données personnelles le concernant. Il lui suffit d’écrire par e-mail à l’adresse contact@viseet.me en indiquant ses noms, prénom, e-mail adresse et si possible sa référence client. Conformément à la réglementation en vigueur, cette demande doit être signée et accompagnée de la photocopie d'un titre d'identité portant la signature du demandeur et préciser l'adresse à laquelle doit lui parvenir la réponse. Une réponse lui sera alors adressée dans un délai de deux (2) mois suivant la réception de la demande. S’il ne souhaite pas recevoir d’informations commerciales de VISEET, il est invité à le préciser dans son e-mail. Conformément à la loi n° 78-17 du 6 janvier 1978, aucune information personnelle n'est collectée à l’insu du client.",
                    'mentions'
                )}
            </p>
            <h3>{__('Responsabilité', 'mentions')}</h3>
            <p>
                {__(
                    "VISEET décline toute responsabilité en cas de difficulté d'accès à son site ou d'interruptions dans la connexion quelles qu'en soient les causes. De plus, il ne saurait être tenu responsable d'un dommage ou virus qui pourrait infecter votre ordinateur ou tout matériel informatique, suite à une utilisation du site ou accès au site ou téléchargement provenant de ce site.",
                    'mentions'
                )}
            </p>
            <h3>
                {__('Exonération de la responsabilité technique', 'mentions')}
            </h3>
            <p>
                {__(
                    "VISEET ne saurait garantir l’exactitude et l’exhaustivité des informations diffusées sur le site. Il ne saurait ainsi être tenu pour responsable des erreurs ou omissions, ainsi que des indisponibilités d’informations. Les informations consultables sur le site le sont à titre informatif et constituent une offre de services et de produits. Elles sont susceptibles d'être modifiées à tout moment, compte tenu de l'interactivité du site, sans que cela puisse engager la responsabilité de VISEET.",
                    'mentions'
                )}
            </p>
            <h3>
                {__(
                    'Exonération de la responsabilité du contenu des sites référencés',
                    'mentions'
                )}
            </h3>
            <p>
                {__(
                    "Les liens hypertextes mis en place dans le cadre du présent site Internet en direction d'autres ressources présentes sur le réseau Internet ne sont proposés que pour des raisons de commodité et ni leur contenu ou les liens qu'ils contiennent, ni les changements ou mises à jour qui leur sont apportés ne sauraient engager la responsabilité du site www.viseet.me",
                    'mentions'
                )}
            </p>
            <h3>{__('Loi Applicable', 'mentions')}</h3>
            <p>
                {__(
                    'Les présentes conditions générales sont régies exclusivement par la loi française. La langue des présentes mentions est la langue française. En cas de traduction, seule la version française fait foi. A défaut de règlement amiable, le Tribunal de commerce de Nanterre sera seul compétent pour tout litige ou différent les concernant.',
                    'mentions'
                )}
            </p>
            <h3>{__('Mises à jour', 'mentions')}</h3>
            <p>
                {__(
                    'Nous pouvons être amenés à modifier cette page périodiquement. En conséquence, nous vous invitons à consulter régulièrement nos mentions légales.',
                    'mentions'
                )}
            </p>
        </RichLayout>
    );
};

Mentions.getInitialProps = async () => {
    return {
        namespacesRequired: ['common']
    };
};

export default Mentions;
